module.exports = __webpack_public_path__ + "img/puk_shin2_mo.2e1101e0.png";